import { Component, ElementRef, Input, KeyValueDiffers, Renderer, ViewChild, IterableDiffers } from '@angular/core';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

import { CardItemModel } from '../../model/card/card-item-model';
import { AccordionItemModel } from '../../model/accordion/accordion-item-model';


const HTML_TEMPLATE = `
<div style="padding-left: 0px;" ion-item no-lines *ngFor="let item of items, let i = index, let l = last">
  <button style="padding-left: 0px;" ion-item no-lines (click)="expandItem(item)">
    <div class="title" ion-item no-lines>
      {{item.title}}
      <ion-icon name="ios-arrow-down" *ngIf="!item.expanded" style="padding-right:16px" item-end no-lines></ion-icon>
      <ion-icon name="ios-arrow-up" *ngIf="item.expanded" style="padding-right:16px" item-end no-lines></ion-icon>
    </div>
    <div class="separator"></div>
    <div *ngIf="item.text" id="expand-wrapper-text{{i}}" class='expand-wrapper' [class.collapsed]="!item.expanded">
      <div id="content-text{{i}}" class="accordion-content" [ngClass]="{ 'last-content' : l }" innerHTML="{{item.text}}"></div>
    </div>
  </button>
  <div *ngIf="item.cards" id="expand-wrapper-card{{i}}" class='expand-wrapper' [class.collapsed]="!item.expanded">
    <div id="content-card{{i}}">
      <ion-list>
        <card-item *ngFor="let card of item.cards" [card]="card" (click)="onClickCard(card)">
        </card-item>
      </ion-list>
    </div>
  </div>
  <div *ngIf="item.checks" id="expand-wrapper-check{{i}}" class='expand-wrapper' [class.collapsed]="!item.expanded">
    <div id="content-check{{i}}">
      <ion-list>
        <ion-item *ngFor="let checkItem of item.checks">
            <ion-checkbox [(disabled)]="checkItem.disabled" class="item-check" [(ngModel)]="checkItem.checked" ></ion-checkbox>
            <span item-content [ngClass]="{ 'label-disabled': checkItem.disabled }">{{checkItem.label}}</span>
        </ion-item>
      </ion-list>
    </div>
  </div>
</div>
`;

const CSS_STYLE = `    
.expand-wrapper {
    transition: 0.5s ease;
    white-space: normal;
    padding-bottom: 0px;
}

.accordion-content {
    font-size: 14px !important;
    padding-top: 24px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 0px;
}

.last-content {
    padding-bottom: 16px !important;
}

.collapsed {
    height: 0 !important;
}

.separator {
    border-bottom: 1px solid #eceeee;
}

.title {
    color: #0c9abe;
    font-size: 14px !important;
    font-weight: bold;
}

card-item h2 {
    font-size: 14px !important;
}

card-item ion-item {
    padding: 4px !important;
}

.label {
    margin: 0;
}

.item-inner {
    padding-right: 0px !important;
    padding-left: 0px !important;
}

.item-check {
    padding-left: 16px;
}

.label-disabled {
    opacity: 0.3;
}

/**/


`;


/*@Component({
    selector: 'accordion-list',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})*/

export class AccordionListComponent {

    @ViewChild('expandWrapperText', { read: ElementRef }) expandWrapperText;
    @ViewChild('expandWrapperCard', { read: ElementRef }) expandWrapperCard;
    @ViewChild('expandWrapperCheck', { read: ElementRef }) expandWrapperCheck;
    @Input('expanded') expanded;
    @Input('firstExpanded') firstExpanded;
    @Input('clickCard') clickCard: Function;
    @Input('items') items: AccordionItemModel[];

    icon: string = "ios-arrow-down";

    private _itemCount: number;

    constructor(public renderer: Renderer,
        private elRef: ElementRef,
        private _screenOrientation: ScreenOrientation) {
    }

    ngAfterViewInit() {

        this._itemCount = 0;
        this.onChangeItems();

        if (this.firstExpanded) {
            this.expandItem(this.items[0]);
        }

        this._screenOrientation.onChange().subscribe(() => {
            console.log("Orientation Changed");
            this.items.forEach((element, index) => {
                element.expanded = false;
            });
        });
    }

    ngDoCheck() {
        let count = this.getItemCount();
        if (this._itemCount != count) {
            this._itemCount = count;
            this.onChangeItems();
        }
    }

    onChangeItems() {
        // refresh heights
        setTimeout(() => {
            this.items.forEach((element, index) => {
                this.setContentHeight(index);
            });
        }, 10);
    }

    getItemCount(): number {
        let count = this.items.length;
        this.items.forEach((element) => {
            if (element.cards)
                count += element.cards.length;
            if (element.checks)
                count += element.checks.length;
        });
        return count;
    }

    setContentHeight(index) {
        var expandWrapper = this.elRef.nativeElement.querySelector('#expand-wrapper-text' + index);
        var accordionContent = this.elRef.nativeElement.querySelector('#content-text' + index);
        if (!expandWrapper) {
            expandWrapper = this.elRef.nativeElement.querySelector('#expand-wrapper-card' + index);
            accordionContent = this.elRef.nativeElement.querySelector('#content-card' + index);
            if (!expandWrapper) {
                expandWrapper = this.elRef.nativeElement.querySelector('#expand-wrapper-check' + index);
                accordionContent = this.elRef.nativeElement.querySelector('#content-check' + index);
            }
        }
        if (expandWrapper)
            this.renderer.setElementStyle(expandWrapper, 'height', (accordionContent.clientHeight + 20) + 'px');
    }

    expandItem(item) {
        this.items.forEach((element, index) => {
            this.setContentHeight(index);

            if (item == element) {
                element.expanded = !element.expanded;
            }
        });

    }

    onClickCard(card: CardItemModel) {
        this.clickCard(card);
    }

}
